import React, { useState } from 'react'
import { Dialog, DialogSpin } from 'components'
import { Button, Hidden, Typography } from '@mui/material'
import {
  useApproveAndSendProceedingsMutation,
  successSnack,
  useRejectProceedingMutation,
} from 'features'
import { useDispatch } from 'react-redux'
import { assetsFormatter } from 'formatters'
import numeral from 'numeral'

export default function RejectProceedingsDialog(_props) {
  const {
    togglerComponent: Component = { Button },
    children,
    togglerProps = {},
    proceedingsList = [],
    newStatus = 's',
    successCallback = null,
    errorCallback = null,
  } = _props

  const [open, setOpen] = useState(false)

  const dispatch = useDispatch()

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setOpen(false)
  }

  const [reject] = useRejectProceedingMutation()

  async function handleSubmit(data) {
    let payload = {
      ProceedingList: _props.proceedingsList.map((proceeding) => ({
        ...proceeding,
        rejectobservation: data.rejectobservation,
      })),
    }
    const mutation = reject(payload)
    mutation
      .then((response) => {
        if (response.data?.message === 'proceeding_rejected') {
          dispatch(
            successSnack({
              message:
                proceedingsList.length === 1
                  ? `lote rechazado`
                  : 'lotes rechazados',
            })
          )
          if (successCallback) successCallback()
          closeDialog()
        }
      })
      .catch((error) => {
        if (errorCallback) errorCallback()
      })
  }
  const mensaje = `¿Estás seguro de rechazar ${
    proceedingsList.length === 1
      ? 'el lote ' + proceedingsList[0].proceedingname
      : proceedingsList.length + ' lotes'
  }?\nEste paso no se puede deshacer.`
  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <Dialog
          open={open}
          handleClose={closeDialog}
          primaryButtonText="Rechazar" //Label of the primary button
          secondaryButtonText="Cancelar" // Label of the cancel button
          title={'Rechazar lote'}
          message={mensaje}
          onSubmit={handleSubmit} // Form submit action
          focusOnFirstInput={false}
          fields={[
            {
              name: 'rejectobservation',
              helperText: `Introduzca un motivo para el rechazo `, // 'Dialog message'
              label: 'Motivo',
              type: 'text',
              validation: {
                required:
                  'El motivo debe ser mayor a 0 y menor o igual a 250 caracteres',
                min: {
                  length: 1,
                  message: 'El motivo debe ser mayor a 0 caracteres',
                },
                max: {
                  length: 250,
                  message: `El motivo no debe superar los 250 caracteres`,
                },
              },
            },
            // {
            //   name: 'rejectobservation',
            //   helperText: `Introduzca un motivo para el rechazo `, // 'Dialog message'
            //   label: 'Motivo',
            //   type: 'text',
            //   focus: true,
            //   validation: {
            //     required:
            //       'El motivo debe ser mayor a 0 y menor o igual a 250 caracteres',
            //     min: {
            //       length: 1,
            //       message: 'El motivo debe ser mayor a 0 caracteres',
            //     },
            //     max: {
            //       length: 250,
            //       message: `El motivo no debe superar los 250 caracteres`,
            //     },
            //   },
            // },
          ]}
        />
      )}
    </>
  )
}
